module.exports = __webpack_public_path__ + "static/media/ai.c7ba005c.png";